import React from "react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, MenuPopup } from "../../layout";
import * as actions from "../../api/actions/pos";
import {
  Avatar,
  Grid,
  IconButton,
  ListItemIcon,
  MenuItem,
  Typography,
} from "@mui/material";

import { CloseReg } from "../pos";
import {
  HomeRounded,
  Logout,
  PointOfSale,
  CategoryRounded,
  CloseRounded,
} from "@mui/icons-material";
import { connect } from "react-redux";
import { controller, endpoints } from "../../api/actions/api";
import { useContext } from "react";
import { AppContext } from "../../App";
import { Button, Select } from "../../controls";
import { useEffect } from "react";

const Header = (props) => {
  const { t } = useTranslation();
  const { _get, _getById, _authUser, _stores, _defStore, _setStore } = props;
  const navigate = useNavigate();
  const [profileEl, setProfileEl] = useState(null);
  const [posEl, setPosEl] = useState(null);
  const [regForm, setRegForm] = useState(false);
  const { setCLoader } = useContext(AppContext);
  const [stores, setStores] = useState([]);
  const [selStore, setSelStore] = useState("");

  useEffect(() => {
    if (_authUser.id !== undefined && _authUser.role === 1) {
      _get(endpoints.Store, actions.ActionType.Store);
      _get(
        endpoints.Store + controller.GetDefStore,
        actions.ActionType.DefStore
      );
    } else if (_authUser.id !== undefined) {
      _getById(
        endpoints.Store + controller.GetById,
        _authUser.storeId,
        actions.ActionType.DefStore
      );
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_authUser]);

  useEffect(() => {
    // Set Store list in the state.
    setStores([
      ..._stores.map((j) => {
        return {
          id: j.id,
          name: j.storeName,
        };
      }),
    ]);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_stores]);

  useEffect(() => {
    if (!_defStore?.id) return;

    // Update selected store in Header
    setSelStore(_defStore.id);

    // Reload inventory for the selected store
    _getById(
      endpoints.Inventory + controller.GetProdsByStore,
      _defStore.id,
      actions.ActionType.SetInventory
    );
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_defStore?.id]);


  const handleShopSelect = (e) => {
    const storeId = Number(e.target.value);

    setSelStore(storeId);

    const selectedStore = _stores.find(
      (j) => j.id === storeId
    );

    if (!selectedStore) return;

    _setStore(
      { result: selectedStore },
      actions.ActionType.DefStore
    );
  };

  const handleNavigate = (url) => {
    navigate(url);
  };
  const handleProfile = (e) => {
    setProfileEl(e.currentTarget);
  };
  const handlePos = (e) => {
    setPosEl(e.currentTarget);
  };
  const handleLogout = () => {
    setCLoader(true);
    const onComplete = (res) => {
      setCLoader(false);
      navigate("/");
    };
    _get(
      endpoints.Auth + controller.Logout,
      actions.ActionType.Auth,
      onComplete
    );
  };

  return (
    <Grid className="d-flex a-center w-100pr j-between">
      <Grid sx={{ display: { md: "block", xs: "none" } }}>
       
        <span className="fw-5 fs-18"> {t("welcome")} {_authUser.firstName}</span>
        <Typography variant="subtitle2">{_defStore.storeName}</Typography>

      </Grid>
      <Grid className="d-flex a-center">
        {/* Shop */}
        {_authUser.role === 1 && (
          <Grid className="mr-10">
            <Select
              className="min-w-150"
              variant="outlined"
              size="small"
              name="shop"
              fullWidth
              value={selStore}
              onChange={handleShopSelect}
              options={stores}
            />
          </Grid>
        )}
        {/* POS Menu */}
        <Grid className="mr-10">
          <Button
            sx={{ height: "40px" }}
            variant="outlined"
            id="pos-menu"
            onClick={handlePos}
            startIcon={<PointOfSale />}
          >
            {t("pos")}
          </Button>
          <MenuPopup anchorEl={posEl} setAnchorEl={setPosEl} id="pos-menu">
            <MenuItem onClick={() => handleNavigate("/pos")}>
              <ListItemIcon>
                <HomeRounded fontSize="small" />
              </ListItemIcon>
              {t("pos")}
            </MenuItem>
            <MenuItem onClick={() => handleNavigate("/pos/categories")}>
              <ListItemIcon>
                <CategoryRounded fontSize="small" />
              </ListItemIcon>
              {t("category")}
            </MenuItem>

            <MenuItem onClick={() => setRegForm(true)}>
              <ListItemIcon>
                <CloseRounded fontSize="small" />
              </ListItemIcon>
              {t("closeRegister")}
            </MenuItem>
          </MenuPopup>

          <Dialog
            show={regForm}
            onClose={false}
            maxWidth="md"
            sx={{
              "& .MuiDialog-paper": {
                margin: "15px",
              },
            }}
          >
            {regForm && <CloseReg {...{ setShowForm: setRegForm }} />}
          </Dialog>
        </Grid>
        {/* Profile Menu */}
        <Grid>
          <IconButton
            onClick={handleProfile}
            aria-controls="account-menu"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <Avatar alt="profile-pic" className="bg-primary" />
          </IconButton>
          <MenuPopup
            anchorEl={profileEl}
            setAnchorEl={setProfileEl}
            id="account-menu"
          >
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              {t("logout")}
            </MenuItem>
          </MenuPopup>
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  _authUser: state.pos.authUser,
  _stores: state.pos.stores,
  _defStore: state.pos.defStore,
});

const mapActiontoProps = {
  _get: actions.get,
  _getById: actions.getById,
  _setStore: actions.clear,
};

export default connect(mapStateToProps, mapActiontoProps)(Header);
